export const TIMEZONE_OPTIONS = [
  { name: 'Saskatchewan, no DST — Regina', value: 'America/Regina' },
  { name: 'Manitoba — Winnipeg', value: 'America/Winnipeg' },
  { name: 'Alberta — Edmonton, Calgary', value: 'America/Edmonton' },

  { name: 'British Columbia — Vancouver', value: 'America/Vancouver' },
  { name: 'British Columbia, no DST — Creston', value: 'America/Creston' },
  { name: 'British Columbia, no DST — Dawson Creek', value: 'America/Dawson_Creek' },
  { name: 'British Columbia, no DST — Fort Nelson', value: 'America/Fort_Nelson' },

  { name: 'Yukon — Whitehorse', value: 'America/Whitehorse' },
  { name: 'Yukon — Dawson City', value: 'America/Dawson' },

  { name: 'Northwest Territories — Inuvik', value: 'America/Inuvik' },

  { name: 'Saskatchewan, no DST — Swift Current', value: 'America/Swift_Current' },

  { name: 'Nunavut — Cambridge Bay', value: 'America/Cambridge_Bay' },
  { name: 'Nunavut — Rankin Inlet', value: 'America/Rankin_Inlet' },
  { name: 'Nunavut — Resolute', value: 'America/Resolute' },
  { name: 'Nunavut — Iqaluit', value: 'America/Iqaluit' },

  { name: 'Ontario, no DST — Atikokan', value: 'America/Atikokan' },
  { name: 'Ontario / Quebec — Toronto', value: 'America/Toronto' },

  { name: 'Quebec, no DST — Blanc-Sablon', value: 'America/Blanc-Sablon' },

  { name: 'Labrador — Goose Bay', value: 'America/Goose_Bay' },
  { name: 'New Brunswick — Moncton', value: 'America/Moncton' },
  { name: 'Nova Scotia — Halifax', value: 'America/Halifax' },
  { name: 'Nova Scotia — Glace Bay', value: 'America/Glace_Bay' },

  { name: "Newfoundland — St. John's", value: 'America/St_Johns' }
];
